<script>
export default {
  name: 'intersect',
  abstract: true,
  props: {
    threshold: {
      type: [Array, Number],
      required: false,
      default: () => [0, 0.2]
    },
    root: {
      type: HTMLElement,
      required: false,
      default: () => null
    },
    rootMargin: {
      type: String,
      required: false,
      default: () => '0px 0px 0px 0px'
    }
  },
  render() {
    return this.$slots.default ? this.$slots.default[0] : null;
  },
  created() {
    this.observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) {
        this.$emit('leave', entries[0]);
      } else {
        this.$emit('enter', entries[0]);
      }
    }, {
      threshold: this.threshold,
      root: this.root,
      rootMargin: this.rootMargin
    });
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$slots.default && this.$slots.default.length > 1) {
        console.warn('Wrap only one element in <intersect> component.');
      } else if (!this.$slots.default || this.$slots.default.length < 1) {
        console.warn('<intersect> component must have only one child');
        return;
      }

      this.observer.observe(this.$slots.default[0].elm);
    });
  },
  destroyed() {
    this.observer.disconnect();
  }
};
</script>
